import { Title, NewDate, Content } from '@/Domain/News/'

export class New {
  private _title: Title
  private _newDate: NewDate
  private _content: Content

  constructor (
    title: Title,
    newDate: NewDate,
    content: Content
  ) {
    this._title = title
    this._newDate = newDate
    this._content = content
  }

  title (): string {
    return this._title.title()
  }

  newDate (): string {
    return this._newDate.date()
  }

  content (): string {
    return this._content.content()
  }
}
